import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
  colors: {
    blue: {
      50: '#ebf5ff',
      100: '#d1e6ff',
      200: '#a3cdff',
      300: '#75b4ff',
      400: '#3e8ffa',
      500: '#3e8ffa',
      600: '#3880e0',
      700: '#3271c7',
      800: '#2b62ae',
      900: '#245395'
    }
  },
  styles: {
    global: {
      body: {
        bg: '#f5f7fb',
        color: '#25324a'
      }
    }
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: 'xl',
        fontWeight: 'semibold',
        _focusVisible: {
          boxShadow: '0 0 0 3px rgba(62, 143, 250, 0.35)'
        }
      },
      variants: {
        outline: {
          borderColor: 'blue.200',
          color: 'blue.700',
          bg: 'white',
          _hover: { bg: 'blue.50' }
        },
        solid: {
          _hover: { bg: 'blue.600' }
        }
      },
      defaultProps: {
        colorScheme: 'blue'
      }
    },
    Heading: {
      baseStyle: {
        color: '#25324a'
      }
    }
  }
})

export default theme 